var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container white"},[_c('div',{staticClass:"venture-list"},_vm._l((_vm.ventures),function(venture){return _c('VentureOverview',{key:venture.id,attrs:{"venture":venture}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }